import { CustomSelect } from '@/components/form/CustomSelect';

/** Метка "Группа не задана" в дропдауне фильтра и в самих строках — как в CustomerTarifTableLayout старой админки. */
export const UNGROUPED_LABEL = 'Группа не задана';

export function GroupFilterSelect({
  groups,
  ungroupedValue,
  value,
  onChange,
}: {
  groups: string[];
  ungroupedValue: string | null;
  value: string;
  onChange: (v: string) => void;
}) {
  if (groups.length === 0 && !ungroupedValue) return null;

  return (
    <div className="group-select">
      <CustomSelect
        value={value}
        onChange={onChange}
        options={[
          { value: '', label: 'Все группы' },
          ...groups.map((g) => ({ value: g, label: g })),
          ...(ungroupedValue ? [{ value: ungroupedValue, label: UNGROUPED_LABEL }] : []),
        ]}
      />
    </div>
  );
}
